import React from 'react';
import {FormGroup} from 'react-bootstrap';
import Select from 'react-select';
// import FontAwesome from 'react-fontawesome';
import {connect} from 'react-redux';
import {setOption} from './FormAction';
// import SWTNewColorModal from '../../../view/workdoc/SWTNewColorModal';
// import WorkdocStore from '../../../stores/WorkdocStore';

class SelectInsurerBranch extends React.Component {

  constructor(...args) {
    super(...args);
    this.initial();
  }

  initial() {

  }

  onFormChange = (e) => {
    const {uiSchema} = this.props
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    let evalue = multi?e:e.value;
    this.props.onChange(evalue);
  };

  render() {
    const {
      // store,
      formData,
      // schema,
      disabled,
      readonly,
      uiSchema
    } = this.props;
    const multi = (uiSchema['ui:multi']!==undefined)?uiSchema['ui:multi']:false
    // const options = this.props.schema.options || {};
    
    return (
        <FormGroup>
          <Select
              multi={multi}
              removeSelected={multi}
              disabled={disabled}
              readOnly={readonly}
              placeholder={'โปรดระบุ'}
              clearable={false}
              value={formData}
            //   options={store.options[options.option_field]
            //            || schema.enum.map((item) => ({label: item, value: item}))
            //            || []}
              options={[]}
              onChange={this.onFormChange}
          >
          </Select>

        </FormGroup>
    );
  }
};

const mapStateToProps = (state) => ({
  store: state,
});

const mapDispatchToProps = ({
  setOption,
});

const SelectCarContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SelectInsurerBranch);

export default SelectCarContainer;



// WEBPACK FOOTER //
// ./src/component/element/workdoc/SelectInsurerBranch.js